import React from 'react';
import { Card } from '@/components/ui/card';
import { AlertCircle } from 'lucide-react';

export const FileInfoCard: React.FC = () => {
  return (
    <Card className="p-3 sm:p-4 bg-blue-50 border-blue-200">
      <div className="flex items-start gap-2 sm:gap-3">
        <AlertCircle className="h-4 w-4 sm:h-5 sm:w-5 text-blue-600 shrink-0 mt-0.5" />
        <div className="text-xs sm:text-sm text-blue-800 space-y-1">
          <p className="font-medium">Før du laster opp:</p>
          <ul className="list-disc list-inside space-y-0.5 pl-1">
            <li>Maks filstørrelse: 100MB</li>
            <li>Støttede formater: MP3, WAV, AAC, FLAC, OGG, M4A</li>
            <li>Les om juridiske implikasjoner for opplasting av filer</li>
          </ul>
        </div>
      </div>
    </Card>
  );
};

